import { useState, useRef } from "react";
import { MenuItem, Fade } from "@mui/material";
import { NavLink } from "react-router-dom";
import Link from "@mui/material/Link";

import { externalRoutes } from "routes";
import { useRouter, useUsers } from "hooks";
import { AUTH_LINKS } from "enums";

import Avatar from "./components/Avatar";
import { StyledMenu } from "./styles";

const AccountMenu = () => {
  const { push } = useRouter();
  const { signOut } = useUsers();
  const [anchorEl, setAnchorEl] = useState(null);
  const pendingPath = useRef(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const closeAccountMenu = () => {
    setAnchorEl(null);
  };

  const handleClose = () => {
    closeAccountMenu();
  };

  const handleItemClick = (event) => {
    event.preventDefault();
    pendingPath.current = event.currentTarget.pathname;
    closeAccountMenu();
  };

  const handleExited = () => {
    if (pendingPath.current) {
      push(pendingPath.current);
      pendingPath.current = null;
    }
  };

  const renderAuthItem = (link) => {
    const { to: pathname, name, id } = link;
    const key = `account-menu-${id}`;

    return (
      <MenuItem id={key} key={key} component={NavLink} to={pathname} onClick={handleItemClick}>
        {name}
      </MenuItem>
    );
  };

  return (
    <>
      <Avatar onClick={handleClick} />
      <StyledMenu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        hideBackdrop
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        TransitionComponent={Fade}
        TransitionProps={{ onExited: handleExited }}
      >
        {AUTH_LINKS.map((link) => renderAuthItem(link))}
        <MenuItem
          id="account-menu-help"
          component={Link}
          href={externalRoutes.helpPath()}
          onClick={handleClose}
          target="_blank"
          rel="noreferrer"
        >
          Help Center
        </MenuItem>
        <MenuItem id="account-menu-logout" onClick={() => signOut()}>
          Log Out
        </MenuItem>
      </StyledMenu>
    </>
  );
};

export default AccountMenu;
